import { html } from 'lit'
import HedeliusBaseItem from '../base-item.js'

class HedeliusParentButton extends HedeliusBaseItem {
    renderAnchor() {
        return html`
            <li class="flex h-16">
                <a
                    @click="${(e) => this._handleClick(e, this.node.parent)}"
                    class="flex items-center text-lg font-light leading-none"
                    href="${this.node.parent.href}"
                >
                    <svg class="back-chevron pr-2" width="28" height="28" viewBox="0 0 16 16">
                        <path
                            d="M10 12l-4-4 4-4"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="1"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                    ${this.node.parent.title}
                </a>
            </li>
        `
    }
}

customElements.define('hedelius-parent-button', HedeliusParentButton)
